export const NAME = 'centres'
export const LABEL = 'Centre'
export const PATH = `/${NAME}/`
export const FORM = 'Centre'

export const subForms = [
  {
    id: 1,
    label: 'Centre',
    path: '/centres/',
    patch: true,
    configName: 'centres'
  },
  {
    id: 2,
    label: 'Communications',
    path: '/centres/communications/',
    configName: 'communications',
    alternatePath: '/centrecommunications/',
    dataFunctionName: 'getCommunicationsData'
  },
  {
    id: 3,
    label: 'Inspections',
    path: '/centres/inspections/',
    configName: 'inspections',
    dataFunctionName: 'getInspectionsData'
  },
  {
    id: 4,
    label: 'Monitoring',
    path: '/centres/monitoring/',
    configName: 'monitoring',
    dataFunctionName: 'getMonitoringData'
  }
]



// WEBPACK FOOTER //
// ./src/centre/constants.js